import * as yup from 'yup'

yup.setLocale({
  mixed: {
    default: '${path} je neplatný',
    required: ({label}) => ({ key: 'mixed.required', values: { label } }),
    oneOf: '${path} musí být jedna z následujících hodnot: ${values}',
    notOneOf: '${path} nes mí být jednou z následujících hodnot: ${values}',
    notType: ({ path, type, value, originalValue }) => {
      let isCast = originalValue != null && originalValue !== value
      let msg =
        `${path} musí být \`${type}\` typ, ` +
        `ale konečná hodnota byla: \`${yup.printValue(value, true)}\`` +
        (isCast ? ` (cast z hodnoty \`${yup.printValue(originalValue, true)}\`).` : '.')

      if (value === null) {
        msg += `\n Pokud je "null" zamýšlená jako prázdná hodnota nezapomeňte schéma označit jako \`.nullable()\``
      }

      return msg
    },
  },
  number: {
    min: '${path} musí být větší nebo rovno ${min}',
    max: '${path} musí být menší nebo rovno ${max}',
    lessThan: '${path} musí být menší než ${less}',
    moreThan: ({path, more}) => ({ key: 'number.moreThan', values: { path, more } }),
    notEqual: '${path} se nesmí rovnat ${notEqual}',
    positive: '${path} musí být kladné číslo',
    negative: '${path} musí být záporné číslo',
    integer: '${path} musí být celé číslo',
  },
  string: {
    length: '${path} musí být přesně ${length} znaků',
    min: ({path, min}) => ({ key: 'string.min', values: { path, min } }),
    max: '${path} musí mít maximálně ${max} znaků',
    matches: '${path} musí odpovídat následujícímu: "${regex}"',
    email: ({path}) => ({ key: 'string.email', values: { path } }),
    url: '${path} musí být platná URL',
    trim: '${path} musí být oříznutý řetězec',
    lowercase: '${path} musí být řetězec malých písmen',
    uppercase: '${path} musí být řetězec velkých písmen',
  },
  date: {
    min: '${path} pole musí být později než ${min}',
    max: '${path} pole musí být dříve než ${max}',
  },
  array: {
    min: 'pole ${path} musí obsahovat alespoň ${min} položek',
    max: '${path} pole musí mít méně nebo rovno ${max} položek',
  },
})

export default yup